import * as React from 'react';

export const BankAccountTab = () => {
  return <div>TBA tab content: BankAccountTab</div>;
};
